import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import { Button } from '../components/ui/button';
import { apiService } from '../services/api';

const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No confirmation token found in the link.');
      return;
    }
    apiService.confirmEmail(token)
      .then((res) => {
        setMessage(res.data.detail);
        setStatus('success');
      })
      .catch((err) => {
        setMessage(err?.response?.data?.detail || 'This confirmation link is invalid or has expired.');
        setStatus('error');
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthShell
      topRightCta={{ label: 'Log in', kind: 'ghost', onClick: () => navigate('/login') }}
    >
      <div className="auth-center">
        {status === 'loading' && (
          <>
            <h1 className="auth-heading">
              Confirming your <span className="auth-heading__accent">email…</span>
            </h1>
            <p className="auth-subheading">Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 className="auth-heading">
              Email <span className="auth-heading__accent">confirmed!</span>
            </h1>
            <p className="auth-subheading">{message}</p>
            <Button className="auth-btn-block" onClick={() => navigate('/app')}>
              Go to dashboard
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="auth-heading">
              Link <span className="auth-heading__accent">invalid</span>
            </h1>
            <p className="auth-subheading">{message}</p>
            <Button className="auth-btn-block" onClick={() => navigate('/login')}>
              Back to log in
            </Button>
          </>
        )}
      </div>
    </AuthShell>
  );
};

export default ConfirmEmailPage;
